export default __webpack_public_path__ + "static/media/fsharp.9a7948f1.svg";